import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import {ConnectedRouter} from 'connected-react-router'
import configureStore, {history} from './store/configureStore'
import App from './container/App'
import { initSentry } from './utils/sentry'

// 从商城等外站返回时，浏览器可能用往返缓存恢复旧页面，站内 history 的栈已经对不上。
// 这时再进邀请好友等页面，返回会渲染出错。缓存恢复一律重新加载，让路由按地址重新初始化。
window.addEventListener('pageshow', event => {
    if (event.persisted) {
        window.location.reload()
    }
})

export const store = configureStore()

const rootEl = document.getElementById('root')

initSentry()
if (process.env.REACT_APP_VCONSOLE === 'true') {
    import(/* webpackChunkName: "vconsole" */ 'vconsole').then(({default: VConsole}) => {
        new VConsole()
    })
}

if (process.env.NODE_ENV !== 'test') {
    // 兼容jest

    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>,
        rootEl
    )
    // registerServiceWorker();
}
